import React, {useMemo} from "react";
import useProductFilterOptions from "src/core/products/hooks/useProductFilterOptions";
import useThemeConfig from "src/themes/useThemeConfig";
import {
  getGroupsFromBrands,
  getGroupsFromCategories,
  getGroupsFromTags,
} from "src/core/products/components/ShowCaseProductsList/utils";

export default function ShowCaseProductsList({
  type,
  filters,
  actionsSortFilter,
  viewAllPosition,
  showBrands = false,
}) {
  const config = useThemeConfig();
  const ThemedShowCaseProductsList = config.components.ShowCasedProductsList;

  const [catalog] = useProductFilterOptions({filters}, ["filters"]);
  const groups = useMemo(() => {
    if (!catalog) return [];
    const tagGroups = !filters.tags ? getGroupsFromTags(catalog.tags, filters) : [];
    const categoryGroups = getGroupsFromCategories(catalog.categories, filters);
    const brandGroups = showBrands ? getGroupsFromBrands(catalog.brands, filters) : [];
    return [...tagGroups, ...categoryGroups, ...brandGroups];
  }, [filters, catalog]);

  const hasGroups = groups.length > 0;

  return (
    <ThemedShowCaseProductsList
      type={type}
      filters={filters}
      groups={groups}
      hasGroups={hasGroups}
      actionsSortFilter={actionsSortFilter}
      viewAllPosition={viewAllPosition}
    />
  );
}
